import Garmin from 'utils/GarminConstants';

var GCSyncUtil = {
    openAgent: function(deviceId) {
        if (deviceId == null || typeof deviceId == 'undefined') {
            if (typeof console !== 'undefined' && console.log) {
                this.log("A device id wasn't passed into GCSyncUtil.openAgent()");
            }
            deviceId = ''; // We don't want Express not to open just because we didn't provide a deviceId.
        }

        this.log('calling ' + Garmin.Queue.Constants.GC_SYNC_URL + '?deviceId=' + deviceId);

        window.location.assign(Garmin.Queue.Constants.GC_SYNC_URL + '?deviceId=' + deviceId);
    },

    log: function(msg) {
        if (typeof console !== 'undefined' && console.log) {
            console.log(new Date() + ': ' + msg);
        }
    },

    scrollToRank: function(scrollAmount) {
        var animateObject = { scrollTop: scrollAmount };
        jQuery('body,html').animate(animateObject);
    }
};

export default GCSyncUtil;
